module.exports = "//static.hsappstatic.net/growth-onboarding-confetti/static-1.1080/images/sprocket.svg"